import { render, staticRenderFns } from "./salesCustomer.vue?vue&type=template&id=0835fd06&scoped=true&"
import script from "./salesCustomer.vue?vue&type=script&lang=js&"
export * from "./salesCustomer.vue?vue&type=script&lang=js&"
import style0 from "./salesCustomer.vue?vue&type=style&index=0&id=0835fd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835fd06",
  null
  
)

export default component.exports